// @ts-nocheck
// TODO: types

import Vue from "vue";

/* by louis */

function isArrayPart(part: string) {
  return part.includes("[");
}

function keyExists(part: string, referencePointer: object) {
  return !(part in referencePointer) || referencePointer[part] === null;
}

function getIndex(part: string) {
  let index = part.split("[");
  index = index[1];
  index = index.split("]");
  index = index[0];
  return index;
}

function getKey(part: string): string {
  let key = part.split("[");
  key = key[0];
  return key;
}

// TODO: this function apparently doesnt work if the object has a key with a value of undefined.
const VueSimpleDeepset = function (
  object: object,
  path: string,
  value: unknown
) {
  if (path.charAt(path.length - 1) === "]") {
    throw "last item in the path can not be an array. path.part[3].something is allowed. path.something.part[3] is not.";
  }

  const pathParts = path.split(".");

  let referencePointer = object;

  let i = 0;
  for (const part of pathParts) {
    i++;

    if (isArrayPart(part)) {
      const index = getIndex(part);
      const key = getKey(part);

      if (Array.isArray(referencePointer[key])) {
        if (index < referencePointer[key].length) {
          if (i < pathParts.length) {
            /* move the reference pointer to the current part and index */
            referencePointer = referencePointer[key][index];
          }
        } else {
          referencePointer[key].push({});
          if (i < pathParts.length) {
            /* move the reference pointer to the last item in the array */
            referencePointer =
              referencePointer[key][referencePointer[key].length - 1];
          }
        }
      } else {
        /* creating array and initializing with blank object at index 0 */

        Vue.set(referencePointer, key, []);

        referencePointer[key].push({});
        if (i < pathParts.length) {
          /* move the reference pointer to the current part and index */
          referencePointer = referencePointer[key][0];
        }
      }
    } else {
      /* it's not an array */
      /* create the key on the object if it doesn't exist */
      if (keyExists(part, referencePointer)) {
        Vue.set(referencePointer, part, {});
      }

      if (i < pathParts.length) {
        /* move the reference pointer to the current part */
        referencePointer = referencePointer[part];
      }
    }

    if (i === pathParts.length) {
      /* we're at the end, set the value */
      Vue.set(referencePointer, part, value);
    }
  }
};

export default VueSimpleDeepset;
